import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Avatar,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import Header from "../componets/Header";
import Footer from "../componets/Footer";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import banner from "../assets/banner4.png";
import internship from "../assets/Internship.png";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import web from "../assets/web.jpg";
import liveproject from "../assets/liveproject.png";
import digitalmarketing from "../assets/digital-marketing.png";

const reviews = [
  {
    name: "Akhil R",
    role: "Student – React Frontend",
    review:
      "The React frontend classes were very clear and practical. Building components and working with Material-UI helped me understand how real websites are developed.",
  },
  {
    name: "Sanjana KP",
    role: "Student – React Frontend",
    review:
      "I liked the hands-on approach in this training. Working on real React projects and responsive designs improved my confidence a lot.",
  },
  {
    name: "Neha S",
    role: "Student – Digital Marketing",
    review:
      "Digital marketing sessions were easy to follow. I learned SEO basics, social media marketing, and how ads work with real examples.",
  },
  {
    name: "Rahul K",
    role: "Student – Digital Marketing",
    review:
      "Practical assignments helped me understand digital marketing better. The trainer explained concepts clearly and answered all doubts.",
  },
  {
    name: "Pooja N",
    role: "Student – React Frontend",
    review:
      "Working on frontend projects helped me understand React workflow, API usage, and UI structure used in real applications.",
  },
  {
    name: "Kiran M",
    role: "Student – React Frontend",
    review:
      "The training started from basics and slowly moved to advanced topics. This helped me understand React without feeling confused.",
  },
  {
    name: "Divya R",
    role: "Student – Digital Marketing",
    review:
      "I learned how to plan content, run ads, and analyze results. The practical approach made digital marketing easier to understand.",
  },
  {
    name: "Manoj D",
    role: "Student – React Frontend",
    review:
      "Live coding sessions and project work helped me improve my frontend coding skills and understand best practices.",
  },
];

const Internship = () => {
  const [startIndex, setStartIndex] = useState(0);
  const handleNext = () => {
    setStartIndex((prev) => (prev + 1) % reviews.length);
  };

  const handlePrev = () => {
    setStartIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  const visibleReviews = [
    reviews[startIndex % reviews.length],
    reviews[(startIndex + 1) % reviews.length],
    reviews[(startIndex + 2) % reviews.length],
  ];

  return (
    <>
      <Header />
      <Box
        sx={{
          height: { xs: "40vh", md: "60vh" },
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Dark overlay */}
        <Box
          sx={{
            position: "absolute",
            // inset: 0,
            // backgroundColor: "rgba(0,0,0,0.6)",
          }}
        />
        {/* Hero content */}
        <Box
          sx={{
            // position: "relative",
            color: "#fff",
            textAlign: "center",
            px: 2,
          }}
        >
          <Typography
            sx={{
              color: "white",
              fontWeight: 800,
              fontSize: { xs: "2.1rem", md: "3.5rem", lg: "4.5rem" },
              textAlign: "center",
              // mb: 3,
              textShadow: "0 4px 8px rgba(0,0,0,0.3)",
            }}
          >
            Internship Program
          </Typography>
          <Typography sx={{ mt: 0, mb: 4, fontSize:{xs:15,md:20} }}>
            Digital Marketing and Web Development with Live Projects. Build
            real-world skills, gain hands-on experience,
            <br />
            and earn an industry-recognised certificate.
          </Typography>
          <Button
            variant="contained"
            size="large"
            component="a"
            href="https://docs.google.com/forms/d/1WckLDJ14VzNTgx0vNdsX-llRu5LNxjneCUfulC8LG0Q/edit?usp=forms_home&ouid=102942792614397822452&ths=true"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              backgroundColor: "#fff",
              color: "#1A4B83",
              fontWeight: "bold",
              px: 5,
            }}
          >
            Apply Now
          </Button>
        </Box>
      </Box>

      {/* ================= ABOUT US ================= */}
      <Box sx={{ p:{xs:4,md:10} }}>
        <Grid container spacing={6} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              component="img"
              src={internship}
              alt="About Internship"
              sx={{
                width: "100%",
                height: { xs: 250, md: 380 },
                objectFit: "cover",
                borderRadius: 4,
                boxShadow: 6,
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography
              fontWeight="bold"
              // textAlign="center"
              sx={{
                color: "#1A4B83",
                textAlign:{
                  xs:'center',md:'left'
                },
                borderBottom: "2px solid #1A4B83",
                pb: 1,
                width: "fit-content",
                // mx: "auto",
                fontSize: {xs:20,md:29},
                mb: 2,
              }}
            >
              About Our Internship Program
            </Typography>
            <Typography color="text.secondary" mb={2} sx={{textAlign:'justify'}}>
              Our 3-month internship program is designed to bridge the gap
              between academic learning and real-world industry requirements. We
              focus on providing hands-on experience through live projects,
              expert mentorship, and practical training.
            </Typography>
            <Typography color="text.secondary" mb={3} sx={{textAlign:'justify'}}>
              Whether you are a student or a working professional, this
              internship helps you develop in-demand skills in Digital Marketing
              and Web Development, preparing you for real career opportunities
              in today’s competitive job market.
            </Typography>
            <Button
              variant="contained"
              size="large"
              sx={{
                backgroundColor: "#1A4B83",
                fontWeight: "bold",
                px: 4,
              }}
            >
              Learn More
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* ================= WHY CHOOSE US ================= */}
      <Box sx={{ px: { xs: 2, md: 10 }, py: 10, backgroundColor: "#f5f9ff" }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          sx={{
            color: "#1A4B83",
            borderBottom: "4px solid #1A4B83",
            pb: 1,
            width: "fit-content",
            mx: "auto",
            mb: 4,
          }}
        >
          Why Choose Us
        </Typography>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card
              sx={{
                p: 2,

                height: 250,
                textAlign: "center",
                borderRadius: 4,
                boxShadow: 6,
              }}
            >
              <Avatar
                sx={{
                  bgcolor: "#1A4B83",
                  width: 64,
                  height: 64,
                  mx: "auto",
                  mb: 2,
                  mt: 2,
                }}
              >
                🎯
              </Avatar>
              <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                Real-Time Live Projects
              </Typography>
              <Typography sx={{ mt: 2, textAlign: "center" }}>
                Work on real industry projects that help you understand actual
                workflows, client handling, and professional project execution.
              </Typography>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card
              sx={{
                p: 2,

                height: 250,
                textAlign: "center",
                borderRadius: 4,
                boxShadow: 6,
              }}
            >
              <Avatar
                sx={{
                  bgcolor: "#1A4B83",
                  width: 64,
                  height: 64,
                  mx: "auto",
                  mb: 2,
                  mt: 2,
                }}
              >
                👨‍🏫
              </Avatar>
              <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                Expert Mentorship
              </Typography>
              <Typography sx={{ mt: 2, textAlign: "center" }}>
                Learn directly from experienced professionals who guide you at
                every step, providing feedback, best practices, and valuable
                career insights.
              </Typography>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card
              sx={{
                p: 2,

                height: 250,
                textAlign: "center",
                borderRadius: 4,
                boxShadow: 6,
              }}
            >
              <Avatar
                sx={{
                  bgcolor: "#1A4B83",
                  width: 64,
                  height: 64,
                  mx: "auto",
                  mb: 2,
                  mt: 2,
                }}
              >
                📜
              </Avatar>
              <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                Industry-Recognised Certificate
              </Typography>
              <Typography sx={{ mt: 2, textAlign: "center" }}>
                Receive a verified internship certificate that strengthens your
                resume and LinkedIn profile, improving your job and career
                opportunities.
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* ================= 3 MONTHS INTERNSHIP ================= */}
      <Box sx={{ px: { xs: 2, md: 10 }, py: 10, backgroundColor: "#fff" }}>
        <Typography
         
          fontWeight="bold"
          textAlign="center"
          sx={{
            color: "#1A4B83",
            borderBottom: "4px solid #1A4B83",
            pb: 1,
            width: "fit-content",
            mx: "auto",
            mb: 4,
            fontSize:{xs:22,md:40}
          }}
        >
          3-Month Internship Program
        </Typography>
        <Typography
          textAlign="center"
          color="text.secondary"
          mb={6}
          sx={{ maxWidth: 850, mx: "auto" }}
        >
          A structured 3-month internship program designed to provide hands-on
          training in Digital Marketing, Web Development, and Live Industry
          Projects.
        </Typography>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card sx={{ borderRadius: 4, boxShadow: 6, height: "100%" }}>
              <Box
                component="img"
                src={digitalmarketing}
                alt="Digital Marketing"
                sx={{
                  width: "100%",
                  height: 220,
                  objectFit: "cover",
                  borderTopLeftRadius: 16,
                  borderTopRightRadius: 16,
                }}
              />
              <CardContent>
                <Typography variant="h6" fontWeight="bold" mb={1}>
                  Digital Marketing
                </Typography>
                <Typography
                  component="ul"
                  color="text.secondary"
                  sx={{ pl: 2 }}
                >
                  <li>Search Engine Optimization (SEO)</li>
                  <li>Social Media Marketing & Ads</li>
                  <li>Content Creation & Strategy</li>
                  <li>Google Analytics & Reporting</li>
                  <li>Live Campaign Planning and Execution</li>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card sx={{ borderRadius: 4, boxShadow: 6, height: "100%" }}>
              <Box
                component="img"
                src={web}
                alt="Web Development"
                sx={{
                  width: "100%",
                  height: 220,
                  objectFit: "cover",
                  borderTopLeftRadius: 16,
                  borderTopRightRadius: 16,
                }}
              />
              <CardContent>
                <Typography variant="h6" fontWeight="bold" mb={1}>
                  Web Development
                </Typography>
                <Typography
                  component="ul"
                  color="text.secondary"
                  sx={{ pl: 2 }}
                >
                  <li>HTML, CSS & JavaScript</li>
                  <li>React & Material-UI</li>
                  <li>Responsive Website Design</li>
                  <li>API Integration</li>
                  <li>Project Deployment</li>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card sx={{ borderRadius: 4, boxShadow: 6, height: "100%" }}>
              <Box
                component="img"
                src={liveproject}
                alt="Live Projects"
                sx={{
                  width: "100%",
                  height: 220,
                  objectFit: "cover",
                  borderTopLeftRadius: 16,
                  borderTopRightRadius: 16,
                }}
              />
              <CardContent>
                <Typography variant="h6" fontWeight="bold" mb={1}>
                  Live Projects
                </Typography>
                <Typography
                  component="ul"
                  color="text.secondary"
                  sx={{ pl: 2 }}
                >
                  <li>Work on real-world Industry Projects</li>
                  <li>Understand Client Requirements</li>
                  <li>Team Collaboration and Agile Workflows</li>
                  <li>Deadline-based Project Execution</li>
                  <li>Portfolio-ready Project Development</li>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* ================= WHO CAN JOIN ================= */}
      <Box sx={{ px: { xs: 2, md: 10 }, py: 10, backgroundColor: "#f5f9ff" }}>
        {/* Heading */}
        <Typography
     
          fontWeight="bold"
          textAlign="center"
          sx={{
            color: "#1A4B83",
            borderBottom: "4px solid #1A4B83",
            pb: 1,
            width: "fit-content",
            mx: "auto",
            mb: 4,
            fontSize:{xs:20,md:40}
          }}
        >
          Who Can Join This Internship?
        </Typography>

        <Typography
          textAlign="center"
          color="text.secondary"
          mb={6}
          sx={{ maxWidth: 800, mx: "auto" }}
        >
          This internship is open to anyone eager to learn, gain practical
          skills, and build a strong foundation in Digital Marketing and Web
          Development.
        </Typography>

        <Grid container spacing={4} justifyContent="center" mb={8}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card
              sx={{ p: 2, textAlign: "center", borderRadius: 4, boxShadow: 6,height:150 }}
            >
              <Typography
                sx={{ fontSize: 20, fontWeight: "bold", mt: 2, mb: 1 }}
              >
                UG / PG Students
              </Typography>
              <Typography color="text.secondary">
                Students currently pursuing undergraduate or postgraduate
                degrees and looking for hands-on industry exposure.
              </Typography>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <Card
                    sx={{ p: 2, textAlign: "center", borderRadius: 4, boxShadow: 6,height:150 }}
            >
              <Typography
                sx={{ fontSize: 20, fontWeight: "bold", mt: 2, mb: 1 }}
              >
                Graduated Students
              </Typography>
              <Typography color="text.secondary">
                Degree holders who want practical experience, portfolio
                projects, and better job opportunities.
              </Typography>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <Card
                    sx={{ p: 2, textAlign: "center", borderRadius: 4, boxShadow: 6,height:150 }}
            >
              <Typography
                sx={{ fontSize: 20, fontWeight: "bold", mt: 2, mb: 1 }}
              >
                Career Switchers
              </Typography>
              <Typography color="text.secondary">
                Individuals planning to move into tech or digital roles with
                structured, beginner-friendly training.
              </Typography>
            </Card>
          </Grid>
        </Grid>

        {/* PROGRAM HIGHLIGHTS */}
        <Typography variant="h5" fontWeight="bold" textAlign="center" mb={4}>
          Program Highlights
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {[
            "Comprehensive Hands-on Training",
            "VTU Credit Eligible Program",
            "Live Industry Projects & Case Studies",
            "Guidance from Industry Expert Mentors",
            "Verified Certificate Upon Completion",
          ].map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Card
                sx={{
                  p: 3,
                  textAlign: "center",
                  borderRadius: 3,
                  boxShadow: 4,
                }}
              >
                <Typography sx={{fontSize:15,fontWeight:'bold'}}>✔ {item}</Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* ================= STUDENT REVIEWS ================= */}
      <Box
        sx={{
          p: { xs: 2, md: 10 },
          backgroundColor: "#ffff",
          position: "relative",
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          sx={{
            color: "#1A4B83",
            borderBottom: "4px solid #1A4B83",
            pb: 1,
            width: "fit-content",
            mx: "auto",
            mb: 4,
          }}
        >
          Student Reviews
        </Typography>

        {/* Reviews Wrapper */}
        <Box sx={{ position: "relative" }}>
          {/* Left Arrow */}
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: { xs: 0, md: -60 },
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "#fff",
              boxShadow: 4,
              zIndex: 10,
              width: 48,
              height: 48,
              "&:hover": {
                backgroundColor: "#f0f0f0",
              },
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>

          {/* Reviews Track */}
          <Box
            sx={{
              transition: "transform 0.5s ease",
            }}
          >
            <Grid container spacing={4} sx={{ p: 1 }}>
              {visibleReviews.map((item, index) => (
                <Grid size={{ xs: 12, md: 4, sm: 4 }} key={index}>
                  <Card
                    sx={{
                      p: 4,
                      height: 200,
                      borderRadius: 4,
                      boxShadow: 6,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box>
                      <Typography fontWeight="bold" mb={1}>
                        ⭐⭐⭐⭐⭐
                      </Typography>
                      <Typography
                        color="text.secondary"
                        mb={2}
                        sx={{ lineHeight: 1.4 }}
                      >
                        “{item.review}”
                      </Typography>
                    </Box>

                    <Box sx={{ mt: "auto", display: "flex", gap: 1 }}>
                      <AccountCircleIcon />
                      <Typography fontWeight="bold">{item.name}</Typography>
                      {/* <Typography variant="body2" color="text.secondary">
                        {item.role}
                      </Typography> */}
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Right Arrow */}
          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: { xs: 0, md: -60 },
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "#fff",
              boxShadow: 4,
              zIndex: 10,
              width: 48,
              height: 48,
              "&:hover": {
                backgroundColor: "#f0f0f0",
              },
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        </Box>
      </Box>

      <Footer />
    </>
  );
};

export default Internship;

